import DocumentUploadWizardNewVersion from './DocumentUploadWizardNewVersion';
export default DocumentUploadWizardNewVersion;